import { ContentfulImageAPI } from './contentfulUtils'

export const getSiteIdByLanguageCode = (language: string) => {
  let siteId = 1
  switch (language) {
    case 'en-GB':
      siteId = 2
      break
    case 'en-IE':
      siteId = 3
      break
    case 'en-CA':
      siteId = 4
      break
    case 'es-US':
      siteId = 11
      break
    case 'zh-US':
      siteId = 12
      break
    default:
      siteId = 1
  }
  return siteId
}
export const getLanguageByCountryCode = (country: string) => {
  let languageCode = 'en-US'
  switch (country.toUpperCase()) {
    case 'UK':
      languageCode = 'en-GB'
      break
    case 'IE':
      languageCode = 'en-IE'
      break
    case 'CA':
      languageCode = 'en-CA'
      break
    case 'ES-US':
      languageCode = 'es-US'
      break
    case 'ZH-US':
      languageCode = 'zh-US'
      break
    default:
      languageCode = 'en-US'
  }
  return languageCode
}

export const getCountryNameByCountryCode = (country: string) => {
  let countryName = 'United States'
  switch (country.toUpperCase()) {
    case 'UK':
      countryName = 'United Kingdom'
      break
    case 'IE':
      countryName = 'Ireland'
      break
    case 'CA':
      countryName = 'Canada'
      break
    default:
      countryName = 'United States'
  }
  return countryName
}

export const getLocalizedEntries = (
  slug: string,
  regions: any[],
  currentRegion: string
) => {
  regions = regions.filter((region: any) => region.country !== currentRegion)
  return regions.map((region: any) => {
    const language = getLanguageByCountryCode(region.country)
    return {
      slug: slug,
      language: language,
      siteId: getSiteIdByLanguageCode(language)
    }
  })
}

export const getAllEntries = (slug: string, regions: any[]) => {
  return regions.map((region: any) => {
    const language = getLanguageByCountryCode(region.country)
    return {
      slug: slug,
      slugOverride: region.slugOverride,
      language: language,
      siteId: getSiteIdByLanguageCode(language)
    }
  })
}

export const getSiteUrl = (defaultSiteUrl: string, language: string) => {
  let siteUrl: string | string[] = defaultSiteUrl.split('/')
  let regionString =
    language && language !== 'en-US'
      ? `${language.toLowerCase().split('-')[1]}`
      : ''
  if (regionString === 'gb') {
    regionString = 'uk'
  }
  if (language && language !== 'en-US') {
    siteUrl.splice(3, 0, regionString)
  }
  siteUrl = siteUrl.join('/')
  return siteUrl
}

export type JSONValue =
  | string
  | number
  | boolean
  | { [x: string]: JSONValue }
  | JSONValue[]

export const isAbsoluteUrl = (url: string): boolean => {
  // Regular expression to check if the URL is absolute (starts with http://, https://, or //)
  return /^(?:[a-z]+:)?\/\//i.test(url)
}

export const prependHostName = (
  data: JSONValue,
  hostName: string
): JSONValue => {
  if (Array.isArray(data)) {
    return data.map((item) => prependHostName(item, hostName))
  } else if (typeof data === 'object' && data !== null) {
    const updatedObject: { [key: string]: JSONValue } = {}
    for (const key in data) {
      if (
        (key === 'url' || key === 'href' || key === 'demoUrl') &&
        typeof data[key] === 'string'
      ) {
        const urlValue = data[key] as string
        // Only prepend hostName if the URL is not absolute
        updatedObject[key] = isAbsoluteUrl(urlValue)
          ? urlValue
          : `${hostName}${urlValue}`
      } else {
        updatedObject[key] = prependHostName(data[key], hostName)
      }
    }
    return updatedObject
  }
  return data
}

export const getEntryImages = (hero: any, thumbnailImage?: any) => {
  return [
    {
      heroImage: hero.image && [getImage(hero.image)],
      thumbnailImage: thumbnailImage && [getImage(thumbnailImage)]
    }
  ]
}

export const getImage = (contentfulImage: any) => {
  const image = contentfulImage
  if (image && image.file) {
    const query = ContentfulImageAPI.transformImageAvif()
    const srcset = ContentfulImageAPI.transformImageAvifSrcset({
      url: image.file.url,
      widths: [320, 640, 768, 1024, 1280, 1536, 1920]
    })

    let imageUrl = image.file.url + query
    if (!imageUrl.includes('http')) {
      imageUrl = `https:${imageUrl}`
    }
    return {
      typeHandle: 'image',
      extension: image.file.contentType,
      url: image.file.url,
      title: image.title,
      imgClasses: '',
      optimizedImages: {
        src: image.file.url,
        srcset: srcset,
        srcsetMaxWidth: '',
        srcsetAvif: srcset,
        placeholderBox: '',
        placeholderImage: '',
        maxSrcsetWidth: '',
        srcAvif: imageUrl
      }
    }
  }
}

// Rename oldProperty to newProperty
export const renameProperty = (obj: any, oldProp: string, newProp: string) => {
  if (obj.hasOwnProperty(oldProp)) {
    obj[newProp] = obj[oldProp] // Copy the value to the new property
    delete obj[oldProp] // Delete the old property
  }
}
